import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Size, Mode, Margin, IconPosition } from '../types/type';

@Component({
  selector: 'custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss']
})
export class CustomButtonComponent implements OnInit {

  @Input() id: string;
  @Input() mode: Mode = 'primary';
  @Input() label: string;
  @Input() iconSrc: string;
  @Input() iconPosition: IconPosition = 'before';
  @Input() disabled: boolean = false;
  @Input() margin: Margin = 'medium';
  @Input() size: Size ;
  @Input() tabIndexValue: number = 0;
  @Input() applyclass: string;

  @Input() widthFromParent: boolean = false;

  @Output() onClick = new EventEmitter();


  // @Output() valueChange = new EventEmitter();
  // @Output() selectedChange = new EventEmitter();
  // @Output() clearOrSelectedChange = new EventEmitter();
  // @Output() change = new EventEmitter();
  // @Output() blur = new EventEmitter();

  controlledValue = '';

  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    //onInit
  }

  onButtonClick() {
    this.onClick.emit();
  }

}
